<sub-header [isModal]="true" [windowHash]=windowHash [includeContextHelp]="true"></sub-header>
<p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <ng-container *ngIf="loaded">
          <ng-container *ngIf="webProject; else appletProject">
            <ng-container *ngIf="tenderingPhases; else emptyPhases">
              <p-accordion [multiple]="true" [activeIndex]="indexes" class="col-12">
                <p-accordionTab *ngFor="let phase of tenderingPhases">
                  <p-header>
                    <span class="header phase">{{ phase.type.description }}</span> <span
                      class="header envelopes">{{ getEnvelopes(phase)}}</span>
                  </p-header>
                  <ng-container
                    *ngTemplateOutlet="phaseTemplate; context: { phase: phase, phaseSubmission: getPhaseSubmission(phase)}">
                  </ng-container>
                </p-accordionTab>
              </p-accordion>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</p-scrollPanel>

<ng-template #phaseTemplate let-phase="phase" let-phaseSubmission="phaseSubmission">
  <div class="row">
    <h3 class="col-12">{{ 'TenderInfo.phaseData' | translate}}</h3>
    <dl class="col-12 row">
      <dt class="col-3 col-xs-12">{{ 'General.date.ini' | translate}}</dt>
      <dd class="col-9 col-xs-12">{{ phase.initDate | date: 'dd/MM/yyyy HH:mm:ss' }}</dd>
      <dt class="col-3 col-xs-12">{{ 'General.date.end' | translate}}</dt>
      <dd class="col-9 col-xs-12">{{ phase.endDate | date: 'dd/MM/yyyy HH:mm:ss' }}</dd>
    </dl>
    <h3 class="col-12">{{ 'TenderInfo.submmisionData' | translate}}</h3>
    <ng-container *ngIf="phaseSubmission">
      <div class="col-12">
        <ng-container *ngTemplateOutlet="phaseStatus; context: { phaseSubmission: phaseSubmission}"></ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="phaseSubmission; else noSubmission">
      <ng-container *ngTemplateOutlet="submissionInfo; context: { submission: phaseSubmission}"></ng-container>
    </ng-container>
  </div>

  <ng-template #nonElectronicSubmission>
    <dt class="col-3 col-xs-12">{{ 'TenderInfo.presentationDate' | translate }} </dt>
    <dd class="col-9 col-xs-12">
      {{ phaseSubmission.submittedEnvelopes[0].date | date: 'dd/MM/yyyy HH:mm:ss' }} </dd>
  </ng-template>

  <ng-template #noSubmission>
    <div class="col-12 mt-1">{{ 'TenderInfo.notSubmitted' | translate }}</div>
    <div class="col-12 mt-1">
      <upload-files [files]="[]" [documentClass]="getDocumentClass()"
        (addItem)="createNewTenderSubmission($event, phase)" [cancelWaitWhenFinished]="false">
      </upload-files>
    </div>
  </ng-template>
</ng-template>

<ng-template #emptyPhases>
  {{'TenderInfo.empty.emptyPhases' | translate}}
</ng-template>

<ng-template #appletProject>
  <div class="row">
    <div class="col-12" *ngIf="!submissions || submissions.length === 0">
      <div class="alert alert-warning m-b-xs text-ellipsis col-12" role="alert"><span>
          <i aria-hidden="true" class="fas fa-1-5x fa-exclamation-circle m-r-md"></i>
          {{'TenderInfo.empty.submissionFiles' | translate }}</span>
      </div>
    </div>
    <div class="col-12" *ngIf="submissions && submissions.length > 0">
      <ng-container *ngTemplateOutlet="phaseStatus; context: { phaseSubmission: submissions[0]}"></ng-container>
    </div>
    <h3 class="col-12">{{ 'TenderInfo.applet.documents' | translate}}</h3>
    <ng-container
      *ngIf="submissions && submissions.length > 0 && (submissions[0].paxe?.file || submissions[0].footPrint?.file); else noSubmissionApplet">
      <ng-container *ngTemplateOutlet="submissionInfo; context: { submission: submissions[0]}"></ng-container>
    </ng-container>
  </div>

  <ng-template #noSubmissionApplet>
    <div class="col-12 mt-1">{{ 'TenderInfo.notSubmitted' | translate }}</div>
    <div class="col-12 mt-1">
      <upload-files [files]="[]" [documentClass]="getDocumentClass()"
        (addItem)="createNewTenderSubmission($event, undefined)" [cancelWaitWhenFinished]="false">
      </upload-files>
    </div>
  </ng-template>
</ng-template>

<ng-template #submissionInfo let-submission="submission">
  <div class="col-12">
    <button class="d-block btn btn-sm btn-secondary w-100 m-b-sm" (click)="getStatus(submission)"><i
        class="fas fa-check"></i> {{'TenderInfo.submissions.validate' | translate}}</button>
    <dl class="col-12 row">
      <ng-container
        *ngIf="submission.communication && submission.communication.registerInfo; else nonElectronicSubmission">
        <dt class="col-3 col-xs-12">{{ 'TenderInfo.registerDate' | translate }}</dt>
        <dd class="col-9 col-xs-12">
          {{ submission.communication.registerInfo.date | date: 'dd/MM/yyyy HH:mm:ss' }}</dd>
        <dt class="col-3 col-xs-12">{{ 'TenderInfo.registerNumber' | translate }}</dt>
        <dd class="col-9 col-xs-12">{{ submission.communication.registerInfo.registerNumber }}</dd>
      </ng-container>
      <dt class="col-12">
        <!-- TITLE -->
        <div class="titleElement">
          {{ 'TenderInfo.paxe' | translate }}
        </div>
      </dt>
      <dd class="col-12">
        <upload-files [files]="(submission.paxe)? [submission.paxe.file] : []"
          [documentClass]="getDocumentClass('paxe')" (deleteItem)="deletePaxe(submission)"
          (addItem)="addPaxe($event, submission, uploadPaxe)" [cancelWaitWhenFinished]="false" #uploadPaxe>
        </upload-files>
        <ng-container *ngIf="submission.paxe && submission.paxe.file">
          <div class="col-12 mt-1 d-flex justify-content-center">
            <button class="btn btn-sm btn-secondary  m-t-sm" (click)="getHash(submission)"
              [attr.disabled]="(submission.paxe.hash != undefined) ? 'disabled' : undefined">
              <i class="fas fa-fingerprint"></i> {{ 'Actions.hash' | translate }}</button>
          </div>
          <div class="col-12 mt-1" *ngIf="submission.paxe.hash">
            <div class="col-12 alert alert-info">
              <div class="paxeAlgorithm">{{'General.algorithm' | translate : '{ alg: "SHA-512" }'}}</div>
              <div class="paxeHash">{{submission.paxe.hash}}</div>
            </div>
          </div>
        </ng-container>
      </dd>
      <dt class="col-12">

        <!-- TITLE -->
        <div class="titleElement">
          {{ 'TenderInfo.footprint' | translate }}
        </div>
      </dt>
      <dd class="col-12">


        <upload-files [files]="(submission.footPrint) ? [submission.footPrint.file] : []"
          [documentClass]="getDocumentClass('footPrint')" (deleteItem)="deleteFootPrint(submission)"
          (addItem)="addFootPrint($event, submission)" [cancelWaitWhenFinished]="false">
        </upload-files>
      </dd>
    </dl>
  </div>
</ng-template>

<ng-template #phaseStatus let-phaseSubmission="phaseSubmission">
  <div class="alert m-b-xs text-ellipsis col-12" [ngClass]="getAlertClass(phaseSubmission.status)" role="alert"
    *ngIf="phaseSubmission.status">
    <i aria-hidden="true" class="fas m-r-md" [ngClass]="getAlertIcon(phaseSubmission.status)"></i>
    {{getAlertMessage(phaseSubmission.status)}}
  </div>
</ng-template>
